import { memo } from "react";
import { AspectRatio, Box, Image, SimpleGrid, Text } from "@chakra-ui/react";

const ProductCollectionImage = ({ collections = [], onOpenCollection, commonConfig = {} }) => {
  const roundImage = commonConfig?.round_image === true;
  const showName = commonConfig?.show_name !== false;

  return (
    <SimpleGrid columns={3} columnGap="2" rowGap="4">
      {collections.map((item) => {
        const image = item.avatar || item.image || item.banner;
        return (
          <div
            key={item.id}
            onClick={() => onOpenCollection(item)}
            style={{ cursor: "pointer", padding: 4 }}
          >
            <Box style={{ width: "62%", margin: "0 auto" }}>
              <AspectRatio ratio={1}>
                <Image
                  src={image?.md_url || image?.lg_url || image?.url}
                  borderRadius={roundImage ? "full" : 8}
                  objectFit="cover"
                />
              </AspectRatio>
            </Box>
            {showName && (
              <Text lineClamp={2} mt={2} textAlign="center" textStyle="sm" color="fg.muted">
                {item.title}
              </Text>
            )}
          </div>
        );
      })}
    </SimpleGrid>
  );
};

export default memo(ProductCollectionImage);
